// Adjust swatch hover images to match rendered container width
// Works alongside collection-script.js by updating image URLs when swatch images are inserted
(function(){
  function computeWidth(container){
    if(!container) return 400;
    var w = Math.round(container.clientWidth);
    return (w && w > 0) ? w : 400;
  }

  function setWidthParam(url, w){
    try {
      // Replace existing width=NNN or append if missing
      if(/([?&])width=\d+/.test(url)){
        return url.replace(/([?&])width=\d+/, '$1width=' + w);
      }
      return url + (url.indexOf('?') === -1 ? '?width=' + w : '&width=' + w);
    } catch(e){
      return url;
    }
  }

  function adjustNode(img){
    if(!(img instanceof HTMLImageElement)) return;
    if(!img.classList || !img.classList.contains('swatch')) return;
    var container = img.closest('.collection__item-bg-img-color-swatches');
    if(!container) return;
    var w = computeWidth(container);
    var src = img.getAttribute('src') || '';
    if(!src) return;
    var newSrc = setWidthParam(src, w);
    if(newSrc !== src){
      img.src = newSrc;
    }
  }

  function scanExisting(){
    document.querySelectorAll('.collection__item-bg-img-color-swatches img.swatch').forEach(adjustNode);
  }

  function init(){
    scanExisting();
    var obs = new MutationObserver(function(mutations){
      mutations.forEach(function(m){
        if(m.type === 'childList'){
          m.addedNodes && m.addedNodes.forEach(function(node){
            if(node instanceof Element){
              if(node.matches && node.matches('.collection__item-bg-img-color-swatches img.swatch')){
                adjustNode(node);
              } else {
                node.querySelectorAll && node.querySelectorAll('.collection__item-bg-img-color-swatches img.swatch').forEach(adjustNode);
              }
            }
          });
        }
      });
    });
    obs.observe(document.documentElement || document.body, {childList:true, subtree:true});
    window.addEventListener('resize', function(){
      // On resize, re-adjust current swatch images to new width
      scanExisting();
    });
  }

  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

